<template>
    <div id="linkMagicFunnel" class="modal inmodal fade modal-v5">
        <div class="modal-dialog">
            <div class="ba-card ba-w-50 ba-mg-t-4">
              <div class="ba-flex ba-jc-sb ba-top ba-mg-t-2 ba-pd-x-2">
                  <div class="ba-title">
                    <span class="ba-color-blue19 ba-montserrat-600" style="font-size: 22px;" v-html="view.translations.magic_funnel.link_generator"></span>
                  </div>
                  <div class="ba-box-items ba-flex ba-jc-fe">
                    <button type="button" class="ba-btn ba-btn-close ba-sm ba-rounded" data-dismiss="modal" aria-hidden="true">
                      <builderall-icon code="64f7" />
                    </button>
                  </div>
              </div>
              <builderall-loader :loading="loading">
              <div class="ba-content ba-pd-x-2 ba-mg-b-2">
                <div class="ba-pd-t-1 ba-mg-r-1">
                  <span class="ba-montserrat-500" style="font-size: 14px;" v-html="view.translations.magic_funnel.info_magic_funnel"></span>
                </div>

                <!-- <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <h4 class="modal-title" v-html="view.translations.magic_funnel.link_generator"></h4>
                    <fs5-collapse-info :view="[view.translations.magic_funnel.magic_funnel_title,view.translations.magic_funnel.info_magic_funnel]"></fs5-collapse-info>
                </div> -->
                <div class="ba-w-100 ba-mg-t-2">
                    <div class="form-group check-group">
                        <input type="checkbox" class="checkbox-lg" id="mgc__add_user_id" ref="mgc__add_user_id" v-model="mgcAddUserIdModel"/>
                        <label class="label-fontsize ba-mg-l-1" v-html="view.translations.magic_funnel.link_generator_add_user_id"></label>
                        <br>
                        <div class="ba-mg-l-2">
                          <span class="label_tip description-checkbox" v-html="view.translations.magic_funnel.link_generator_add_user_id_not_selected"></span>
                        </div>
                    </div>
                    <div class="form-group check-group" v-if="showIgnoreErrors">
                        <input type="checkbox" class="checkbox-lg" id="mgc__ignore_error" ref="mgc__ignore_error" v-model="mgcIgnoreErrorModel"/>
                        <label class="label-fontsize ba-mg-l-1" v-html="view.translations.magic_funnel.ignore_errors"></label>
                        <br>
                        <div class="ba-mg-l-2">
                          <span class="label_tip description-checkbox" v-html="view.translations.magic_funnel.ignore_errors_desc"></span>
                        </div>
                    </div>
                    <!-- <div :class="['form-group check-group', (view.data.dados_usuario_office.affiliate_type == view.data.constList.affiliate_type_pro) ? '' : 'hide']"> -->
                    <div :class="['form-group check-group hide']">
                        <input type="checkbox" class="checkbox-lg" id="mgc__free_plan" ref="mgc__free_plan" v-model="mgcRegisterFreePlanModel"/>
                        <label v-html="view.translations.magic_funnel.link_generator_register_free_plan"></label>
                    </div>
                    <div class="form-group check-group">
                        <input type="checkbox" class="checkbox-lg" id="mgc__cheetah_va" ref="mgc__cheetah_va" v-model="mgcCheetahVaModel"/>
                        <label class="label-fontsize ba-mg-l-1" v-html="view.translations.magic_funnel.link_generator_cheetah_va"></label>
                        <div class="ba-mg-l-2">
                          <span class="label_tip description-checkbox" v-html="view.translations.magic_funnel.link_generator_tip_cheetah_va"></span>
                        </div>
                    </div>
                    <div v-if="statusSelectTrialDays" class="form-group check-group">
                        <input type="checkbox" class="checkbox-lg" id="mgc__trial_plan" ref="mgc__trial_plan" @click="checkTrialDays()" :checked="checkStatusTrialDays"/>
                        <label class="label-fontsize ba-mg-l-1" v-html="view.translations.magic_funnel.title_trial_day_plan"></label>
                        <div class="ba-mg-l-2">
                          <span class="label_tip description-checkbox" v-html="view.translations.magic_funnel.subtitle_trial_day_plan"></span>
                        </div>
                    </div>
                    <div v-if="checkStatusTrialDays">
                        <div class="ba-box-input ba-mg-y-1">
                            <div class="ba-info">
                                <div class="ba-info-left">
                                    <label class="ba-label is-required label-fontsize ba-montserrat-500" v-html="view.translations.magic_funnel.trial_day_plan"></label>
                                </div>
                            </div>
                            <select class="ba-select ba-lg" name="" id="mgc__trial_plan" ref="mgc__trial_plan" v-model="planSelectTrialDays" :style="mgc__trial_plan">
                              <option value="all">{{view.translations.magic_funnel.choose_trial_day_plan}}</option>
                              <option v-for="(planTrial,i) in plansTrialDays" :key="i" :value="planTrial.token">
                                  {{planTrial.title}}
                              </option>
                            </select>
                        </div>

                        <!-- <select id="mgc__trial_plan" ref="mgc__trial_plan" class="form-control" v-model="planSelectTrialDays" :style="mgc__trial_plan">
                        <option value="">{{view.translations.magic_funnel.choose_trial_day_plan}}</option>
                            <option v-for="(planTrial,i) in plansTrialDays" :key="i" :value="planTrial.token">
                                {{planTrial.title}}
                            </option>
                        </select> -->
                        <!-- <span class="label_error" id="mgc__error_trial_plan" ref="mgc__error_trial_plan" :style="mgc__error_trial_plan" v-html="view.translations.magic_funnel.link_generator_error_plan"></span> -->
                    </div>
                    <div class="form-group radio-group">
                        <label class="is-required label-fontsize" v-html="view.translations.magic_funnel.link_generator_redirect_after_register"></label>
                        <div class="ba-mg-y-1">
                          <input type="radio" name="mgc__option" id="mgc__option_url"  value="url" :checked="mgcOption == 'url'"  @click="radioInputEventListener('url')" />
                          <label class="label-fontsize" for="mgc__option_url" v-html="view.translations.magic_funnel.link_generator_enter_an_url"></label>
                        </div>
                        <div>
                          <input v-if="statusTrialRadioPlan" type="radio" name="mgc__option" id="mgc__option_plan" value="plan" @click="radioInputEventListener('plan')"/>
                          <label class="label-fontsize" v-if="statusTrialRadioPlan" for="mgc__option_plan" v-html="view.translations.magic_funnel.link_generator_choose_a_plan"></label>
                        </div>
                    </div>
                    <div class="form-group" id="mgc__div_plan" ref="mgc__div_plan">
                        <div class="ba-box-input ba-mg-y-1">
                            <div class="ba-info">
                                <div class="ba-info-left">
                                    <label class="ba-label is-required label-fontsize ba-montserrat-500" v-html="view.translations.magic_funnel.link_generator_plan"></label>
                                </div>
                            </div>
                            <select class="ba-select ba-lg" id="mgc__plan" ref="mgc__plan" :style="mgcPlanStyle" v-model="mgcPlanModel" >
                              <option value="">
                                {{view.translations.magic_funnel.link_generator_plan_placeholder}}
                              </option>
                              <optgroup v-for="plan in plans" v-if="plan.items.length" :label="plan.title" :key="plan.id">
                                  <option  v-for="item in plan.items" :key="item.id" :data-currency="item.plan_currency.toLowerCase()" :value="item.plan_slug" :data-coupon="item.coupon_code"> {{ item.title}}</option>
                              </optgroup>
                            </select>
                        </div>
                        <!-- <label class="is-required" v-html="view.translations.magic_funnel.link_generator_plan"></label>
                        <select id="mgc__plan" ref="mgc__plan" class="form-control" :style="mgcPlanStyle" v-model="mgcPlanModel">
                            <option value="">
                                {{view.translations.magic_funnel.link_generator_plan_placeholder}}
                            </option>
                            <optgroup v-for="plan in plans" v-if="plan.items.length" :label="plan.title" :key="plan.id">
                                <option  v-for="item in plan.items" :key="item.id" :data-currency="item.plan_currency.toLowerCase()" :value="item.plan_slug" :data-coupon="item.coupon_code"> {{ item.title}}</option>
                            </optgroup>
                        </select> -->
                        <!-- <span class="label_error" id="mgc__error_plan" ref="mgc__error_plan" :style="mgcErrorPlanStyle" v-html="view.translations.magic_funnel.link_generator_error_plan"></span> -->
                    </div>
                    <div class="form-group" id="mgc__div_url" ref="mgc__div_url" >
                        <div class="ba-box-input ba-mg-y-1">
                            <div class="ba-info">
                                <div class="ba-info-left">
                                    <label class="ba-label is-required label-fontsize ba-montserrat-500" v-html="view.translations.magic_funnel.link_generator_url"></label>
                                </div>
                            </div>
                            <input
                                type="text"
                                class="ba-input"
                                :placeholder="view.translations.magic_funnel.link_generator_url_placeholder"
                                id="mgc__url"
                                ref="mgc__url"
                                v-model="mgcUrlModel"
                                :style="mgcUrlStyle"
                            />
                        </div>
                        <!-- <label class="is-required" v-html="view.translations.magic_funnel.link_generator_url"></label>
                        <input type="text" class="form-control" :placeholder="view.translations.magic_funnel.link_generator_url_placeholder" id="mgc__url" ref="mgc__url" v-model="mgcUrlModel" :style="mgcUrlStyle"/>
                        <span class="label_error" id="mgc__error_url" ref="mgc__error_url" :style="mgcErrorUrlStyle" v-html="view.translations.magic_funnel.link_generator_error_url"></span> -->
                    </div>
                    <div class="form-group" id="mgc__div_origin" ref="mgc__div_origin">
                        <div class="ba-box-input ba-mg-y-1">
                            <div class="ba-info">
                                <div class="ba-info-left">
                                    <label class="ba-label is-required label-fontsize ba-montserrat-500" v-html="view.translations.magic_funnel.link_generator_origin"></label>
                                </div>
                            </div>
                            <input
                                type="text"
                                class="ba-input"
                                :placeholder="view.translations.magic_funnel.link_generator_origin_placeholder"
                                id="mgc__origin"
                                ref="mgc__origin"
                                v-model="mgcOriginModel"
                                :style="mgcOriginStyle"
                            />
                        </div>
                        <!-- <label id="origin_label" style="width: 100%; position: relative;">
                            {{view.translations.magic_funnel.link_generator_origin}}
                            <span id="mgc__origin_help" @click="showOriginPopover()">?</span>
                        </label>
                        <input type="text" class="form-control" :placeholder="view.translations.magic_funnel.link_generator_origin_placeholder" id="mgc__origin" ref="mgc__origin" v-model="mgcOriginModel" :style="mgcOriginStyle"/>
                        <span class="label_error" id="mgc__error_origin" ref="mgc__error_origin" :style="mgcErrorOriginStyle">
                            {{view.translations.magic_funnel.link_generator_error_url}}
                        </span>
                        <span class="label_tip" style="margin-top: 10px;">
                            {{view.translations.magic_funnel.link_generator_origin_tip}}
                        </span> -->
                    </div>
                    <div class="form-group">
                        <div class="ba-box-input ba-mg-y-1">
                            <div class="ba-info">
                                <div class="ba-info-left">
                                    <label class="ba-label is-required label-fontsize ba-montserrat-500" v-html="view.translations.magic_funnel.link_generator_mb_list"></label>
                                </div>
                            </div>
                            <select class="ba-select ba-lg" id="mgc__mb_lists" ref="mgc__mb_lists" v-model="mgcMbListsModel" >
                              <option value="">
                                {{view.translations.magic_funnel.link_generator_mb_list_placeholder}}
                              </option>
                            </select>
                        </div>
                        <!-- <label v-html="view.translations.magic_funnel.link_generator_mb_list"></label>
                        <select id="mgc__mb_lists" ref="mgc__mb_lists" class="form-control" v-model="mgcMbListsModel">
                            <option value="">
                                {{view.translations.magic_funnel.link_generator_mb_list_placeholder}}
                            </option>
                        </select> -->
                    </div>
                    <hr class="ba-hr-row">
                    <div style="margin: 1rem 0">
                      <div class="ba-flex">
                        <button href="#" @click.prevent="showAdvanced = true" v-if="!showAdvanced" style="background: none; border: none">
                          <span class="ba-color-blue19 ba-montserrat-700 label-fontsize">{{ view.translations.magic_funnel.show_advanced_settings }}</span>
                        </button>
                        <button href="#" @click.prevent="showAdvanced = false" v-else style="background: none; border: none">
                          <span class="ba-color-blue19 ba-montserrat-700 label-fontsize">{{ view.translations.magic_funnel.hide_advanced_settings }}</span>
                        </button>
                      </div>
                      <div v-show="showAdvanced" style="margin-top: 1rem;">
                        <div class="form-group check-group">
                          <input type="checkbox" class="checkbox-lg" id="mgc__send_registration_data" ref="mgc__send_registration_data" v-model="mgcSendRegistrationDataModel"/>
                          <label class="label-fontsize ba-mg-l-1"v-html="view.translations.magic_funnel.forward_registration_data"></label>
                          <div class="ba-mg-l-2">
                            <span class="label_tip description-checkbox" v-html="view.translations.magic_funnel.forward_registration_data_desc"></span>
                            <span class="label-tip description-checkbox" v-html="view.translations.magic_funnel.forward_registration_data_cadastro_telefone_tip"></span>
                          </div>
                            <!-- <input type="checkbox" class="checkbox-lg" id="mgc__send_registration_data" ref="mgc__send_registration_data" v-model="mgcSendRegistrationDataModel"/> -->
                            <!-- <label v-html="view.translations.magic_funnel.forward_registration_data"></label> -->
                            <!-- <span class="label_tip" v-html="view.translations.magic_funnel.forward_registration_data_desc"></span> -->
                            <!-- <span class="label_tip" v-html="view.translations.magic_funnel.forward_registration_data_cadastro_telefone_tip"></span> -->
                        </div>

                        <div class="form-group">
                          <label class="label-fontsize" v-html="view.translations.magic_funnel.custom_param"></label>
                          <div>
                            <span class="label_tip description-checkbox" v-html="view.translations.magic_funnel.custom_param_desc"></span>
                          </div>
                            <!-- <label class="labe-default" v-html="view.translations.magic_funnel.custom_param"></label> -->
                            <!-- <span class="label_tip" v-html="view.translations.magic_funnel.custom_param_desc"></span> -->
                        </div>

                        <div class="form-group form-table" style="margin: 0 !important;">
                          <div class="form-table--header" v-if="!this._isEmpty(mgcCustomParams)">
                            <label class="ba-label label-fontsize" for="input_id" v-html="view.translations.magic_funnel.purposes_integrations_parameters_key"></label>
                            <label class="ba-label label-fontsize" for="input_id" v-html="view.translations.magic_funnel.purposes_integrations_parameters_value"></label>
                            <!-- <span>{{ view.translations.magic_funnel.purposes_integrations_parameters_key }}</span> -->
                            <!-- <span>{{ view.translations.magic_funnel.purposes_integrations_parameters_value }}</span> -->
                          </div>
                          <div class="form-table--body" v-for="(param, index) in mgcCustomParams" :key="index">
                            <input type="text ba-sm" :placeholder="view.translations.magic_funnel.parameter_identifier" v-model="param.key" class="ba-input" />
                            <input type="text" :placeholder="view.translations.magic_funnel.parameter_value" v-model="param.value" class="ba-input" />
                            <button class="ba-btn ba-btn-trash ba-sm" @click="removeCustomParam(index)">
                                <builderall-icon code="trash" />
                            </button>
                            <!-- <input type="text" v-model="param.key" class="form-control" :placeholder="view.translations.magic_funnel.parameter_identifier"/> -->
                            <!-- <input type="text" v-model="param.value" class="form-control" :placeholder="view.translations.magic_funnel.parameter_value"/> -->
                            <!-- <button class="btn btn-block is-primary" @click="removeCustomParam(index)" style="background-color: #FF4848 !important;">
                              <img src="/internacional/public/JTFoxx/img/user-edit/delete.svg">
                              {{ view.translations.magic_funnel.initial_carrousel_remove }}
                            </button> -->
                          </div>
                          <div class="ba-flex ba-jc-center ba-w-100 ba-mg-t-2">
                            <button class="ba-btn ba-md ba-blue ba-flex ba-w-50" @click="addCustomParam()">
                                <builderall-icon code="2780" />
                                <span class="ba-text-capitalize" style="font-size: 12px;">{{ view.translations.magic_funnel.office_tools_add_button }}</span>
                            </button>
                          </div>
                          <!-- <button class="btn btn-block is-primary button-form" @click="addCustomParam()">
                            {{ '+' + view.translations.magic_funnel.office_tools_add_button }}
                          </button> -->
                        </div>
                      </div>
                    </div>
                    <hr class="ba-hr-row">
                    <div class="form-group" id="mgc__div_url_after_payment"  ref="mgc__div_url_after_payment" >
                        <label>
                            {{view.translations.magic_funnel.link_generator_after_payment_url}}
                        </label>
                        <input type="text" class="form-control" :placeholder="view.translations.magic_funnel.link_generator_after_payment_url_placeholder" id="mgc__url_after_payment" ref="mgc__url_after_payment" v-model="mgcUrlAfterPaymentModel" :style="mgcUrlAfterPaymentStyle"/>
                        <span class="label_error" id="mgc__error_url_after_payment" ref="mgc__error_url_after_payment" :style="mgcErrorUrlAfterPaymentStyle">
                            {{view.translations.magic_funnel.link_generator_error_url}}
                        </span>
                    </div>
                    <div class="box-btn-link ba-w-100">
                      <div class="ba-flex ba-jc-fe ba-mg-y-1">
                        <button class="ba-btn ba-lg ba-blue" id="wlg__get_link" ref="wlg__get_link" :disabled="false" @click="getLinkListenner()">
                            <span class="ba-text-capitalize ba-montserrat-400 ba-pd-x-1" v-html="view.translations.magic_funnel.link_generator_get_link"></span>
                        </button>
                      </div>
                        <!-- <button class="btn btn-block is-primary btn-generator" id="wlg__get_link" ref="wlg__get_link" :disabled="false" @click="getLinkListenner()">
                            <b v-if="!showIconAnimation" v-html="view.translations.magic_funnel.link_generator_get_link"></b>
                            <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                            </svg>
                        </button> -->
                        <div v-if="showLink" class="link-generated">
                            <br>
                            <fs6-input-copy class="ba-color-blue19" :view="[view.translations.magic_funnel.your_link_here,generatedLinkModel,view.translations.magic_funnel.copied]"></fs6-input-copy>
                            <!-- <fs5-input-copy :view="[view.translations.magic_funnel.your_link_here,generatedLinkModel,view.translations.magic_funnel.copied]"></fs5-input-copy> -->
                        </div>
                    </div>
                </div>
              </div>
            </builderall-loader>
            </div>
        </div>
    </div>
</template>

<script>

    let language = new URL(location.href).searchParams.get('language');

    export default {
        props: [
            'parentRefs',
        ],
        name: 'modal-magic-funnel-v5',
        data: function() {
            return {
                userLanguage: window.lang || 'us',
                selectedLanguage: language !== undefined && language !== null ? language : (window.lang || 'us'),

                showIconAnimation: false,
                urlIsValid: false,

                apiGetMailingBossLists: "/us/office/franchise-system/list-mailingboss",
                officeUrl: '',
                plans: [],
                plansTrialDays: [],
                statusTrialRadioPlan: true,
                planSelectTrialDays: '',
                checkStatusTrialDays: false,
                statusSelectTrialDays: false,
                maillingBossLists: [],
                openModalBtnElement: undefined, // botao que abre o modal ( ps. via prop pois pode estar em outros niveis da arvore)
                mgcDivPlanElement: this.$refs.mgc__div_plan,
                mgcDivUrlElement: this.$refs.mgc__div_url,
                mgcDivUrlAfetrPaymentElement: this.$refs.mgc__div_url_after_payment,
                mgcOptionElements: document.getElementsByName('mgc__option'),
                getLinkElement:  this.$refs.mgc__get_link,
                generatedLinkElement: this.$refs.mgc__generated_link,
                copyLinkElement: this.$refs.mgc__copy_link,
                generatedResultElement: this.$refs.mgc__generated_result,
                mgcPlanElement: this.$refs.mgc__plan,
                mgcUrlElement: this.$refs.mgc__url,
                mgcMbListsElement: this.$refs.mgc__mb_lists,
                mgcRegisterFreePlanElement: this.$refs.mgc__free_plan,
                mgcAddUserIdElement: this.$refs.mgc__add_user_id,
                mgcIgnoreErrorElement: this.$refs.mgc__ignore_error,
                mgcSendRegistrationDataElement: this.$refs.mgc__send_registration_data,
                mgcCheetahVaElement: this.$refs.mgc__cheetah_va,
                mgcUrlAfterPaymentElement: this.$refs.mgc__url_after_payment,
                mgcErrorUrlElement: this.$refs.mgc__error_url,
                mgcErrorUrlAfterPayment: this.$refs.mgc__error_url_after_payment,
                mgcErrorPlanElement: this.$refs.mgc__error_plan,
                mgcOriginElement: this.$refs.mgc__origin,
                mgcErrorOriginElement: this.$refs.mgc__error_origin,

                showLink: false, // show link generated
                showAdvanced: false,
                showIgnoreErrors: true,

               // dados
                mgcOption: 'url',
                urlRedirect: '',
                planSlug: '',
                mbList: '',
                registerFree: '',
                cheetahVA: '',
                addUserId: '',
                ignoreError: '',
                sendRegistrationData: '',
                urlAfterPayment: '',
                origin: '',
                customParams: [],

                //v-model values
                mgcUrlModel: '',
                mgcPlanModel: '',
                mgcMbListsModel: '',
                mgcRegisterFreePlanModel: false,
                mgcCheetahVaModel: false,
                mgcUrlAfterPaymentModel: '',
                mgcAddUserIdModel: false,
                mgcIgnoreErrorModel: false,
                mgcSendRegistrationDataModel: false,
                mscCustomParameters: false,
                generatedLinkModel: '',
                mgcOriginModel: '',
                mgcCustomParams: [],

                // style vars
                mgcErrorUrlStyle: {},
                mgcErrorPlanStyle: {},
                mgcErrorUrlAfterPaymentStyle: {},
                mgcUrlStyle: {},
                mgcPlanStyle: {},
                mgc__error_trial_plan: {},
                mgc__trial_plan: {},
                mgcUrlAfterPaymentStyle: {},
                mgcErrorOriginStyle: {},
                mgcOriginStyle: {},

                //data
                lang: window.lang || 'us',
                loading: true,
                view: { // prevent undefined bugs
                    data: {
                        constList: {
                            affiliate_type_pro: '',
                            application_env: '',
                            ba_gateway_front: '',
                            host_short_url: ''
                        },
                        'dados_usuario_office': {
                            affiliate_type: '',
                            email: '',
                            id: ''
                        },
                        link_user: '',
                        access_short_url: '',
                    },
                    translations: {
                        magic_funnel:{
                            copied: '',
                            link_generator_add_user_id: '',
                            link_generator_add_user_id_not_selected: '',
                            link_generator_after_payment_url: '',
                            link_generator_after_payment_url_placeholder: '',
                            link_generator_cheetah_va: '',
                            link_generator_choose_a_plan: '',
                            link_generator_enter_an_url: '',
                            link_generator_error_plan: '',
                            link_generator_error_url: '',
                            link_generator_get_link: '',
                            link_generator_here_is_your_link: '',
                            link_generator_mb_list: '',
                            link_generator_mb_list_placeholder: '',
                            link_generator_modal_title_magic_funnel: '',
                            link_generator_plan: '',
                            link_generator_plan_placeholder: '',
                            link_generator_redirect_after_register: '',
                            link_generator_register_free_plan: '',
                            link_generator_tip_cheetah_va: '',
                            link_generator_url: '',
                            link_generator_url_placeholder: '',
                            link_generator_origin: '',
                            link_generator_origin_placeholder: '',
                            link_generator_origin_help: ''
                        }
                    }
                },
            };
        },
        methods: {
            forceInitRefs(){
                this.openModalBtnElement = undefined // botao que abre o modal ( ps. via prop pois pode estar em outros niveis da arvore)
                this.mgcDivPlanElement = this.$refs.mgc__div_plan
                this.mgcDivUrlElement = this.$refs.mgc__div_url
                this.mgcDivUrlAfetrPaymentElement = this.$refs.mgc__div_url_after_payment
                this.mgcOptionElements = document.getElementsByName('mgc__option')
                this.getLinkElement = this.$refs.mgc__get_link
                this.generatedLinkElement = this.$refs.mgc__generated_link
                this.copyLinkElement = this.$refs.mgc__copy_link
                this.generatedResultElement = this.$refs.mgc__generated_result
                this.mgcPlanElement = this.$refs.mgc__plan
                this.mgcUrlElement = this.$refs.mgc__url
                this.mgcMbListsElement = this.$refs.mgc__mb_lists
                this.mgcRegisterFreePlanElement = this.$refs.mgc__free_plan
                this.mgcAddUserIdElement = this.$refs.mgc__add_user_id
                this.mgcCheetahVaElement = this.$refs.mgc__cheetah_va
                this.mgcUrlAfterPaymentElement = this.$refs.mgc__url_after_payment
                this.mgcErrorUrlElement = this.$refs.mgc__error_url
                this.mgcErrorUrlAfterPayment = this.$refs.mgc__error_url_after_payment
                this.mgcErrorPlanElement = this.$refs.mgc__error_plan
                this.mgcOriginElement = this.$refs.mgc__origin
                this.mgcErrorOriginElement = this.$refs.mgc__error_origin
            },
            checkTrialDays() {
                this.checkStatusTrialDays = !this.checkStatusTrialDays;
                this.statusTrialRadioPlan = !this.statusTrialRadioPlan;
                this.radioInputEventListener('url');
                this.handleIgnoreErrorsVisibility();
            },
            // Get link event listener
            getLinkListenner() {
                // sanitize URL's
                this.mgcUrlModel             = this.getValidUrl(this.mgcUrlModel)
                this.mgcUrlAfterPaymentModel = this.getValidUrl(this.mgcUrlAfterPaymentModel)
                this.mgcOriginModel          = this.getValidUrl(this.mgcOriginModel)

                this.urlRedirect     = this.mgcUrlModel
                this.planSlug        = this.mgcPlanModel //
                this.mbList          = this.mgcMbListsModel //
                this.registerFree    = this.mgcRegisterFreePlanModel
                this.cheetahVA       = this.mgcCheetahVaModel
                this.urlAfterPayment = this.mgcUrlAfterPaymentModel
                this.addUserId       = this.mgcAddUserIdModel
                this.ignoreError     = this.mgcIgnoreErrorModel
                this.sendRegistrationData = this.mgcSendRegistrationDataModel
                this.origin          = this.mgcOriginModel
                this.customParams    = this.mgcCustomParams


                // validate form
                let hasError = this.formValidation()
                if(hasError) return

                if(!this.showIconAnimation)
                {
                    this.showIconAnimation = true;
                    setTimeout(() => {
                        this.showIconAnimation = false;
                        document.activeElement.blur();
                    }, 2000);
                }

                this.generatedLinkModel = this.getLink();
                // console.log('link completo: ', this.generatedLinkModel);
                // this.resizeLinkElement();
                // this.generatedResultElement.removeAttribute('hidden');
                this.showLink = true;
            },

            // Link event listener
            linkEventListenner() {
                this.generatedLinkElement.select()
            },

            // Copy event listener
            copyEventListenner(){
                $('#mgc__copy_link').popover('show');
                let vm = this
                setTimeout(() => {
                    $('#mgc__copy_link').popover('hide')
                }, 1000);

                this.generatedLinkElement.select()
                document.execCommand('copy')
            },
            // Radio input event listener
            radioInputEventListener(value){
                this.mgcOption = value;
                this.handleOptions();
            },
            // sanitize a URL to be valid
            getValidUrl(url){

                if(!url) return '';

                let newUrl = window.decodeURIComponent(url);
                newUrl = newUrl.trim().replace(/\s/g, "");

                if(/^(:\/\/)/.test(newUrl)){
                    return `http${newUrl}`;
                }
                if(!/^(f|ht)tps?:\/\//i.test(newUrl)){
                    return `http://${newUrl}`;
                }

                return newUrl;
            },
            // Validate form
            formValidation(){
                this.$set(this.$data, 'mgcErrorUrlStyle', { display:  'none' })
                this.$set(this.$data, 'mgc__error_trial_plan', { display:  'none' })
                this.$set(this.$data, 'mgcErrorUrlAfterPaymentStyle', { display:  'none' })
                this.$set(this.$data, 'mgcUrlStyle', { borderColor:  '#F0F0F0' })
                this.$set(this.$data, 'mgc__trial_plan', { borderColor:  '#F0F0F0' })
                this.$set(this.$data, 'mgcPlanStyle', { borderColor:  '#F0F0F0' })
                this.$set(this.$data, 'mgcUrlAfterPaymentStyle', { borderColor:  '#F0F0F0' })
                this.$set(this.$data, 'mgcErrorOriginStyle', { display:  'none' })
                this.$set(this.$data, 'mgcOriginStyle', { borderColor:  '#F0F0F0' })

                let hasError = false

                // validations
                if(this.checkStatusTrialDays && this.planSelectTrialDays == '')
                {
                    this.$set(this.$data, 'mgc__error_trial_plan', { display:  'block' })
                    this.$set(this.$data, 'mgc__trial_plan', { borderColor:  '#EF4411' })
                    hasError = true
                }

                if(this.mgcOption == 'url')
                {
                    if(!this.urlRedirect || !this.validURL(this.urlRedirect))
                    {
                        this.$set(this.$data, 'mgcErrorUrlStyle', { display:  'block' })
                        this.$set(this.$data, 'mgcUrlStyle', { borderColor:  '#EF4411' })
                        hasError = true
                    }
                }
                else if(this.mgcOption == 'plan')
                {
                    if(!this.planSlug)
                    {
                        this.$set(this.$data, 'mgcErrorPlanStyle', { display:  'block' })
                        this.$set(this.$data, 'mgcPlanStyle', { borderColor:  '#EF4411' })
                        hasError = true
                    }
                }

                if(this.urlAfterPayment)
                {
                    if(!this.validURL(this.urlAfterPayment))
                    {
                        this.$set(this.$data, 'mgcErrorUrlAfterPaymentStyle', { display:  'block' })
                        this.$set(this.$data, 'mgcUrlAfterPaymentStyle', { borderColor:  '#EF4411' })
                        hasError = true
                    }
                }

                if(this.origin){
                    if(!this.validURL(this.origin)){
                        this.$set(this.$data, 'mgcErrorOriginStyle', { display:  'block' })
                        this.$set(this.$data, 'mgcOriginStyle', { borderColor:  '#EF4411' })
                        hasError = true
                    }
                }

                return hasError
            },

            // Validate an url
            validURL(myURL) {
                let regexp =  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/

                if (regexp.test(myURL)) return true

                return false
            },

            // Create the link
            getLink(){
                // base url
                let link = this.officeUrl+'/create'
                // add user id
                if(this.addUserId) link = this.setUrlParam(link, 'aid', this.view.data.dados_usuario_office.id, true)
                // add origin
                if(this.origin != ''){
                    link = this.setUrlParam(link, 'tracking_origin', this.origin, true)
                    link = this.setUrlParam(link, 'tracking_params', 'magic_funnel', true)
                }
                // register the user on the free plan
                if(this.registerFree) link = this.setUrlParam(link, 'plan', 'free', true)
                // allow cheetah va
                if(this.cheetahVA) link = this.setUrlParam(link, 'cheetahva', 'true', true)
                if(this.checkStatusTrialDays && this.planSelectTrialDays != '') link = this.setUrlParam(link, 'tokenreg', this.planSelectTrialDays, true)
                // threating mailingboss list
                if(this.mbList)
                {
                    link = this.setUrlParam(link, 'list_mb', this.mbList, true)
                    link = this.setUrlParam(link, 'email_mb', this.view.data.dados_usuario_office.email, true)
                }

                if(this.ignoreError) link = this.setUrlParam(link, 'ignore-error', 'true', true)

                if(this.sendRegistrationData) link = this.setUrlParam(link, 'send-reg-data', true)

                if (this.customParams.length > 0)
                {

                  let customParamsToSend = []

                  for (let i = 0; i < this.customParams.length; i++) {
                    const param = this.customParams[i];
                    if (param.key != "" && param.value != "") {
                      link = this.setUrlParam(link, param.key, param.value)
                      customParamsToSend.push(param.key)
                    }
                  }

                  if (customParamsToSend.length > 0) link = this.setUrlParam(link, 'custom-params', btoa(customParamsToSend))
                }

                let redir = ''; // variavel local
                // option
                switch (this.mgcOption) {
                    case 'url':
                        link = this.setUrlParam(link, 'redir', '_redir_', true)
                        redir = this.urlRedirect
                        break;

                    case 'plan':
                        let currency    = this.mgcPlanElement.options[this.mgcPlanElement.selectedIndex].getAttribute('data-currency'),
                            coupon      = this.mgcPlanElement.options[this.mgcPlanElement.selectedIndex].getAttribute('data-coupon'),
                            checkoutUrl = this.view.data.constList.ba_gateway_front + '/payment/' + this.planSlug

                        if(coupon)
                        {
                            checkoutUrl = this.setUrlParam(checkoutUrl, 'coupon', coupon, true)
                        }

                        //url after payment
                        if(this.urlAfterPayment)
                        {
                            checkoutUrl = this.setUrlParam(checkoutUrl, 'url-after-payment', '_url_after_payment_', true)
                        }

                        link = this.setUrlParam(link, 'redir', '_redir_', true)

                        redir = checkoutUrl
                        break;
                }

                redir = encodeURIComponent(this.encodeOnlyParams(redir));

                link = link.replace('_redir_', redir)
                if(this.urlAfterPayment){
                    this.urlAfterPayment = this.urlAfterPayment.split('/').join('|')
                    this.urlAfterPayment = this.encodeOnlyParams(this.urlAfterPayment)
                    link = link.replace('_url_after_payment_', this.urlAfterPayment)
                }

                return link
            },

            // Resize the link element to fit to the content
            resizeLinkElement() {
                let txt  = this.generatedLinkModel,
                    cols = this.generatedLinkElement.cols,
                    rows = parseInt(txt.length/(cols*1.5));

                this.generatedLinkElement.rows = rows
            },

            /**
             * Adds or updates a URL parameter.
             */
            setUrlParam(url, param, paramVal, setHowLast) {
                var urlSplited    = url.split('#'),
                    parts         = urlSplited[0].split('?'),
                    baseUrl       = parts[0],
                    newParameters = [];

                // cast boolean
                setHowLast = !!setHowLast;

                if(!setHowLast)
                {
                    if (paramVal !== '' && paramVal !== null && typeof paramVal !== 'undefined')
                    {
                        newParameters.push(param + '=' + encodeURIComponent(paramVal));
                    }
                }

                for(let i=1, len=parts.length; i<len; i++) {

                    let oldQueryString = parts[i];
                    if(!!oldQueryString) {
                        let oldParameters = oldQueryString.split('&');
                        for (let i = 0; i < oldParameters.length; i++) {
                            if(oldParameters[i].split('=')[0] != param) {
                                newParameters.push(oldParameters[i]);
                            }
                        }
                    }
                }

                if(setHowLast) {
                    if (paramVal !== '' && paramVal !== null && typeof paramVal !== 'undefined') {
                        newParameters.push(param + '=' + encodeURIComponent(paramVal));
                    }
                }

                if (newParameters.length > 0) {
                    baseUrl += '?' + newParameters.join('&');
                }

                if(urlSplited.length == 2) {
                    baseUrl += '#' + urlSplited[1];
                }

                return baseUrl;
            },

            encodeOnlyParams(value){
                value = value.split('&').join(encodeURIComponent('&'))
                value = value.split('?').join(encodeURIComponent('?'))
                return value
            },

            // Init the modal
            init: async function (){
                await this.requestDataLinkGenerators()
                this.forceInitRefs()

                let vm = this
                $('#mgc__copy_link').popover({
                    title: '',
                    container: '#mgc__generated_result',
                    content: vm.view.translations.magic_funnel.copied,
                    placement: 'left',
                    trigger: "manual"
                });

                $('#mgc__origin_help').popover({
                    title: '',
                    container: '#origin_label',
                    content: vm.view.translations.magic_funnel.link_generator_origin_help,
                    placement: 'left',
                    trigger: "manual",
                });

                // reset values
                this.mgcUrlModel                  = ''
                this.mgcPlanModel                 = ''
                this.mgcMbListsModel              = ''
                this.mgcRegisterFreePlanModel     = false
                this.mgcCheetahVaModel            = false
                this.mgcAddUserIdModel            = true
                this.mgcIgnoreErrorModel          = false
                this.mgcSendRegistrationDataModel = false
                this.mgcUrlAfterPaymentModel      = ''
                this.mgcOriginModel               = ''

                // initial hide elements
                // this.generatedResultElement.setAttribute('hidden', true)
                this.showLink = false;

                this.handleOptions()

                //getting mailingboss lists
                if(!this.maillingBossLists.length){
                    this.requestMbLists()
                }

            },

            // Handle Options elements
            handleOptions(){
                if(this.mgcOption === 'url')
                {
                    this.mgcDivPlanElement.setAttribute('hidden', true)
                    this.mgcDivUrlElement.removeAttribute('hidden')
                    this.mgcDivUrlAfetrPaymentElement.setAttribute('hidden', true)
                }
                else
                {

                    if(this.plans.length == 0)
                    {
                        this.requestPlans()
                    }
                    this.mgcDivUrlElement.setAttribute('hidden', true)
                    this.mgcDivPlanElement.removeAttribute('hidden')
                    this.mgcDivUrlAfetrPaymentElement.removeAttribute('hidden')
                }
            },

            // Make the request to get MailingBoss Lists
            requestMbLists(){
                let vm = this
                this._ajax({
                    url     : this.apiGetMailingBossLists,
                    data    : '',
                    method  : 'GET',
                    headers : {
                        'X-Requested-With' : 'XMLHttpRequest',
                    },
                    success : function(res) {
                        if(res.status == 'success'){
                            vm.maillingBossLists = res.data.lists

                            //localhost test
                            if(vm.view.data.constList.application_env == 'development'){
                                vm.maillingBossLists = [{id: "mb-1", text: "MB List 1"}, {id: "mb-2", text: "MB List 2"}, {id: "mb-3", text: "MB List 3"}]
                            }

                            vm.handleMbLists(vm.maillingBossLists)
                        }
                    }
                })
            },

            /**
             * Run a Ajax Request
             * @param {Object} obj
             */
            _ajax(obj) {
                let xhttp = new XMLHttpRequest()
                xhttp.open(obj.method, obj.url, true)

                // Set Headers
                Object.keys(obj.headers).map(function(key) {
                    if(key && key.length) {
                        xhttp.setRequestHeader(key, obj.headers[key])
                    }
                })

                xhttp.onreadystatechange = function() {
                    if (xhttp.readyState == 4 && xhttp.status == 200) {
                        obj.success(JSON.parse(xhttp.responseText))
                    }
                }
                xhttp.onerror = function() {
                    console.log('Error.', JSON.parse(this.responseText))
                }

                xhttp.withCredentials = true
                xhttp.send(obj.data)
            },

            // Handle MallingBossa lists elements
            handleMbLists(lists){
                let childs = this.mgcMbListsElement.childNodes

                for (let i = 0; i < childs.length; i++) {
                    if(childs[i].value != ''){
                        childs[i].remove()
                    }
                }

                if(lists.length){
                    for (let i = 0; i < lists.length; i++) {
                        var option = document.createElement("option")
                        option.value = lists[i].id
                        option.text  = lists[i].text

                        this.mgcMbListsElement.appendChild(option)
                    }
                }
            },
            requestDataLinkGenerators: async function (){
                this.loading = true
                try{
                    let res = await axios.get(`/${this.lang}/office/franchise-system/link-generators/data`)
                    res = res.data.data
                    this.$set(this.$data, 'view', res)
                } catch(e) {
                    console.log('error = ', e.getMessage())
                } finally{
                    this.officeUrl = `${this.view.data.constList.url_office}/${this.selectedLanguage}/office`
                    this.loading = false
                }
            },
            requestPlans: async function (){
                let vm = this;
                axios.get(`/${this.lang}/office/magic-funnel-plans`)
                .then((res)=>{
                    if(res.data.success && res.data.magic_funnel_plans){
                        vm.plans = res.data.magic_funnel_plans
                    }
                }).catch((e) => {
                    console.log('error = ', e)
                }).finally(()=>{
                });
            },
            showOriginPopover(){
                $('#mgc__origin_help').popover('toggle');
            },
            addCustomParam () {
              this.mgcCustomParams.push(
                {
                  'key' : '',
                  'value' : ''
                }
              )
            },
            removeCustomParam (index) {
                this.mgcCustomParams.splice(index, 1);
            },
            _isEmpty(val) {
              return isEmpty(val);
            },
            handleIgnoreErrorsVisibility () {
              if (this.mgcOption == 'plan' || this.checkStatusTrialDays) {
                // this.showIgnoreErrors = false;
                // this.mgcIgnoreErrorModel = false;
                return;
              }

              this.showIgnoreErrors = true;
            }
        },
        created(){
            axios
                .get(`/${this.lang}/office/magic-funnel-plans`)
                .then((response) => {
                    if(response.status == 200)
                    {
                        this.plansTrialDays = response.data.magic_funnel_trial_days;
                        if(response.data.magic_funnel_trial_days != null)
                        {
                            this.statusSelectTrialDays = true;
                            this.statusTrialRadioPlan = true;
                        }
                    }
                })
                .catch(e => {});
        },
        watch: {
            mgcUrlModel(newValue,oldValue)
            {
                let regexp =  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{1,})))(?::\d{2,5})?(?:\/\S*)?$/

                if(regexp.test(newValue))
                {
                    this.urlIsValid = true;
                    this.$set(this.$data, 'mgcErrorUrlStyle', { display:  'none' })
                    this.$set(this.$data, 'mgcUrlStyle', { borderColor:  '#F0F0F0' })
                    return;
                }
                this.$set(this.$data, 'mgcErrorUrlStyle', { display:  'block' });
                this.$set(this.$data, 'mgcUrlStyle', { borderColor:  '#EF4411' });
                this.urlIsValid = false;
            },
            mgcOriginModel(newValue,oldValue)
            {
                let regexp =  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{1,})))(?::\d{2,5})?(?:\/\S*)?$/

                if(regexp.test(newValue))
                {
                    this.urlIsValid = true;
                    this.$set(this.$data, 'mgcErrorOriginStyle', { display:  'none' })
                    this.$set(this.$data, 'mgcOriginStyle', { borderColor:  '#F0F0F0' })
                    return;
                }
                this.$set(this.$data, 'mgcErrorOriginStyle', { display:  'block' });
                this.$set(this.$data, 'mgcOriginStyle', { borderColor:  '#EF4411' });
                this.urlIsValid = false;
            },
            mgcOption (newValue, oldValue) {
              this.handleIgnoreErrorsVisibility();
            }
        },
        mounted() {
            $('#linkMagicFunnel').on('show.bs.modal', this.init)
        }
    }
</script>

<style scoped lang="scss">
  .labe-default {
    font-size: 1.125rem !important;
  }
    #origin_label{
        width: 100%;
        position: relative;
    }

    #mgc__origin_help{
        position: absolute;
        background-color: #0080FC;
        border-radius: 15px;
        padding:3px 6px 3px 6px;
        color: white;
        font-weight: bold;
        font-size: 9pt;
        right: 0 !important;
        cursor: pointer;
    }
    .close{
        color: #C4C4C4 !important;
    }
    .modal-content{
        height: 90vh !important;
        width: 55% !important;
        display: grid;
        grid-template-rows: auto auto;
    }
    .modal-title{
        text-align: left !important;
        padding-left: 1em;
        color: #A5B9D5 !important;
        font-size: 1.8em !important;
        font-family: Lato;
        text-transform: uppercase;
    }
    .label-fontsize{
      font-size: 14px;
    }
    .description-checkbox{
      font-size: 14px;
    }
    .modal-body{
        height: 100%;
        overflow: auto;
        .box-btn-link{
            background-color: #EDF1F7;
            border-radius: 5px;
            padding: 1em;
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-between;
            label{
                font-size: .8em !important;
            }
            .box-input-copy{
                width: 100%;
            }
        }
        .btn-generator{
            z-index: 1;
            position: relative;
            border: none;
            width: 100%;
            padding: 0.43em !important;
            svg{
                color: #02EAA0;
                animation-name: svgSuccess;
                animation-duration: 1s;
            }
        }
        .btn-generator::before{
            position: absolute;
            border-radius: 8px;
            z-index: -1;
            content: '';
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            transform: scaleX(0);
            transition: transform .8s ease-in-out;
            transform-origin: left;
            background-color: #0763cc;
        }
        .btn-generator:focus::before{
            transform: scaleX(1);
        }
    }
    .link-generated{
        width: 100%;
    }
    @media only screen and (max-width: 780px) {
        .modal-title{
            font-size: 1.3em !important;
        }
    }
    @keyframes svgSuccess {
        from {transform: rotate(0deg);}
        to {transform: rotate(360deg);}
    }

    .form-table {
      display: flex;
      flex-direction: column;
      .form-table--header {
        grid-template-rows: auto !important;
      }
      .form-table--header,
      .form-table--body {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 8rem;
        grid-template-rows: 50px;
        gap: 1rem;
        margin-bottom: .3rem;
        button {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: .4rem;
        }
      }
      .button-form {
        height: 2rem;
        padding: 0 !important;
      }
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/modals/MagicFunnel.vue